import {
  Box,
  Button,
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { ChildrenInteractionBlocker } from "../../../../components/overlays/ChildrenInteractionBlocker";
import { PERMISSIONS } from "../../../../config/permissions";

export interface WaitingRhBannerProps {
  onApprove: () => void;
  isApproving: boolean;
}

export const WaitingRhBanner = ({ onApprove, isApproving }: WaitingRhBannerProps) => {
  const bg          = useColorModeValue("orange.50", "rgba(251,146,60,0.1)");
  const borderColor = useColorModeValue("orange.200", "orange.700");
  const titleColor  = useColorModeValue("orange.700", "orange.300");
  const subColor    = useColorModeValue("orange.600", "orange.300");

  return (
    <Box p={4} bg={bg} borderRadius="md" borderWidth="1px" borderColor={borderColor} mt={50}>
      <Flex align="center" justify="space-between" gap={3} wrap="wrap">
        <Box>
          <Text fontSize="sm" fontWeight="semibold" color={titleColor}>
            Aguardando ação interna do RH
          </Text>
          <Text fontSize="xs" color={subColor} mt={0.5}>
            O candidato enviou esta missão e está aguardando que o RH conclua os processos internos.
          </Text>
        </Box>
        <ChildrenInteractionBlocker
          requiredPermissions={[PERMISSIONS.RH.APPROVE_MISSIONS]}
          toastMessage="Você não tem permissão para aprovar etapas."
        >
          <Button
            size="sm"
            colorScheme="orange"
            isLoading={isApproving}
            loadingText="Aprovando..."
            onClick={onApprove}
            flexShrink={0}
          >
            Confirmar e liberar candidato
          </Button>
        </ChildrenInteractionBlocker>
      </Flex>
    </Box>
  );
};
